module.exports = __webpack_public_path__ + "static/media/cameraIcon.aa15c1f3.svg";